import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderTypesAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderTypesSlice = createSlice({
  name: 'repairOrderTypes',
  initialState: repairOrderTypesAdapter.getInitialState(),
  reducers: {
    setRepairOrderTypes: (state, { payload: { repairOrderTypes } }) => {
      repairOrderTypesAdapter.setAll(state, repairOrderTypes);
    },
  },
});

const selectors = repairOrderTypesAdapter.getSelectors(
  ({ repairOrderTypes }) => repairOrderTypes,
);

export const getRepairOrderTypes = (state) => selectors.selectAll(state);

export const { setRepairOrderTypes } = repairOrderTypesSlice.actions;

export default repairOrderTypesSlice.reducer;
